/**
 * Which skies Godot debands. ProceduralSkyMaterial and PhysicalSkyMaterial write
 * `render_mode use_debanding` from their `use_debanding` (`sky_material.cpp:377`, `:819`), and
 * PanoramaSkyMaterial writes no such mode.
 */
export function isDebanded(material) {
    return material.kind !== 'panorama' && material.use_debanding;
}
//# sourceMappingURL=debanding.js.map